module.exports = __webpack_public_path__ + "static/media/33.b08f0894.jpg";